/**
 * Percorsi My Focus (collection paths) per tab e sidebar.
 * Dati condivisi tra pagina my-focus e AreaRiservataSidebar.
 */
export interface PathItem {
	id: number;
	code?: string | null;
	title?: string | null;
	short_title?: string | null;
	icon?: string | null;
	color?: string | null;
	sort?: number | null;
}

const PATHS_STATE_KEY = 'area-riservata-paths';

export function useAreaRiservataPaths() {
	const pathsList = useState<PathItem[]>(PATHS_STATE_KEY, () => []);
	const { authFetch } = useAuthFetch();

	async function loadPaths() {
		if (!import.meta.client) return;
		const token = typeof localStorage !== 'undefined' ? localStorage.getItem('directus_access_token') : null;
		if (!token) {
			pathsList.value = [];
			return;
		}
		try {
			const res = await authFetch<{ paths: PathItem[] }>('/api/area-riservata/paths');
			pathsList.value = Array.isArray(res?.paths) ? res.paths : [];
		} catch {
			pathsList.value = [];
		}
	}

	return { pathsList, loadPaths };
}
